<template>
    <div class="category">
        <div @click="isVisible = !isVisible" class="category__sticker bg-default" v-if="!!params.item.description" :class="{
            'category__sticker--active': isVisible
        }">
            <svg class="icon icon_color_white">
                <use xlink:href="/img/sprites/icons-sprite.svg#icon-info"></use>
            </svg>
        </div>
        <div class="category__inner">
            <h2 class="title title_thickness_medium category__title" data-testid="categories-category-header"
                @click="$router.push(`/courses-list/${params.item.id}`)">{{ params.item.name }}</h2>
            <div class="category__row">
                <div class="category__amount" :title="`${$t('catComp.countTitle')}: ${params.item.coursecount}`">
                    <div class="category__total">{{ params.item.coursecount }}</div>
                    <svg class="icon">
                        <use xlink:href="/img/sprites/icons-sprite.svg#icon-book"></use>
                    </svg>
                </div>
                <div class="category__desc-btn" @click="isVisible = !isVisible"/>
            </div>
        </div>
        <Transition name="fade">
            <template v-if="isVisible">
                <div class="category__description" v-if="!!params.item.description"
                     v-html="formatImages(params.item.description)">
                </div>
            </template>
        </Transition>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {formatImages} from '@/script';

export default {
    name: 'Category',
    props: {
        params: {
            type: Object,
            default() {
                return {
                    item: {
                        name: 'Филиал в городе Ишиме',
                        coursecount: 0,
                        description: ''
                    }
                }
            }
        }
    },
    data: () => {
        return {
            isVisible: false
        }
    },
    computed: {
        ...mapGetters(['user'])
    },
    methods: {
        formatImages
    }
}
</script>

<style lang="scss" scoped>
@import './scss/category.scss';

.fade-enter-active,
.fade-leave-active {
    transition: all 0.2s;
    max-height: 230px;
}

.fade-enter-from 
.fade-leave-to {
    opacity: 0;
    max-height: 0px;
}
</style>
